import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_33 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const totalQuoteCountConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.twitter.total_quote_count',
    id: 'quote_count',
    orientation: ORIENTATION_VERTICAL,
    icon: {
        name: 'quotes',
        style: colors.purple
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    tooltip: 'kpi.twitter.tooltip_total_quote_count',
    size: SIZE_33,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
